import { useTheme } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { BaseChartingCard } from "@src/appV2/redesign/Charting/Cards/BaseChartingCard";
import { ChartingCardWrapper } from "@src/appV2/redesign/Charting/Cards/ChartingCardWrapper";
import { Button } from "@src/appV2/redesign/components/Button";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";
// eslint-disable-next-line no-restricted-imports
import UnfinishedTask from "@src/assets/images/unfinishedTask.png";
import { useHistory } from "react-router-dom";

import { type ChartingNoncompliance } from "../api/schema";
import { CHARTING_REDIRECT_PATH } from "../constants";

export interface ChartingViolationCardProps {
  chartingNoncompliance: ChartingNoncompliance;
}

export function ChartingViolationCard(props: ChartingViolationCardProps) {
  const { chartingNoncompliance } = props;
  const theme = useTheme();
  const history = useHistory();

  const { id: chartingNoncomplianceId } = chartingNoncompliance;

  return (
    <ChartingCardWrapper
      image={UnfinishedTask}
      background={theme.palette.charting?.violation.gradient}
    >
      <BaseChartingCard
        title="Limited Access"
        content={
          <Text variant="body1" textAlign="left">
            Complete charting to restore shift access
          </Text>
        }
        footer={
          <Button
            invert
            sx={{
              width: "fit-content",
            }}
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.CHARTING_NONCOMPLIANCE_RESOLVE_VIOLATION, {
                timestamp: new Date().toISOString(),
                chartingNoncomplianceId,
              });
              history.push(CHARTING_REDIRECT_PATH);
            }}
          >
            Resolve now&nbsp;&nbsp;&nbsp;
            <CbhIcon type="chevron-right" size="xSmall" />
          </Button>
        }
      />
    </ChartingCardWrapper>
  );
}
